function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v5H0v-5Z",
    style: {
      fill: "#003082"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,15l15,5v5H0v-5l15-5ZM5,5.465l1.323,4.07-3.463-2.515h4.28l-3.463,2.515,1.323-4.07Z",
    style: {
      fill: "#ffce00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,15h30v5H0v-5Z",
    style: {
      fill: "#289728"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,5h5v20h-5V5Z",
    style: {
      fill: "#d21034"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf);
export default __webpack_public_path__ + "static/media/CF.755b3f6efb72a9d4655749c3f00c94da.svg";
export { ForwardRef as ReactComponent };